import { filterXSS } from "xss"

export const filterHTML = str => {
  if (Array.isArray(str)) {
    const filtered = []
    for (const item of str) {
      filtered.push(filterXSS(item))
    }

    return filtered
  }

  if (str) {
    return filterXSS(str)
  }

  return str
}



// WEBPACK FOOTER //
// ./webapp/scripts/xss.js